import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowList: Components<Theme>['MuiList'] = {
  defaultProps: {
    disablePadding: true,
    // adds dense class to ListItem
    dense: false,
  },
  styleOverrides: {
    root: ({ ownerState }) => ({
      ...(ownerState.inset === false && {
        marginLeft: '-4px',
        marginRight: '-4px',
        maxWidth: 'none',
      }),
    }),
  },
};
